import {
  LABELS,
  STATUS,
  CORPORATE_NUMBER,
  DUNS_NO,
  COMPANY_NAME,
  CONTRACT_SERVICE,
  MERCHANTS_TYPE,
  MERCHANTS_NAME,
  CONTRACT_TYPE,
  CONTRACT_ROUTE,
  QR_PRESENTATION_CATEGORY,
  IPID,
  SITE_ID,
  MERCHANT_MANAGEMENT_NUMBER,
  SHOP_ID,
  TERMINAL_IDENTIFICATION_NUMBER,
  // Orange項目追加
  //  決済グループID
  SETTLEMENT_GROUP_ID,
  //  Access Key
  ACCESS_KEY,
  //  Secret Key
  SECRET_KEY,
} from "./constants";

/** ドコモユーザのみ */
export const columnDefinitionsBase = [
  {
    id: STATUS,
    header: LABELS.STATUS,
  },
  {
    id: CORPORATE_NUMBER,
    header: LABELS.CORPORATE_NUMBER,
  },
  {
    id: DUNS_NO,
    header: LABELS.DUNS_NO,
  },
  {
    id: COMPANY_NAME,
    header: LABELS.COMPANY_NAME,
  },
  {
    id: CONTRACT_SERVICE,
    header: LABELS.CONTRACT_SERVICE,
  },
  {
    id: MERCHANTS_TYPE,
    header: LABELS.MERCHANTS_TYPE,
  },
  {
    id: MERCHANTS_NAME,
    header: LABELS.MERCHANTS_NAME,
  },
  {
    id: CONTRACT_TYPE,
    header: LABELS.CONTRACT_TYPE,
  },
  {
    id: CONTRACT_ROUTE,
    header: LABELS.CONTRACT_ROUTE,
  },
  {
    id: QR_PRESENTATION_CATEGORY,
    header: LABELS.QR_PRESENTATION_CATEGORY,
  },
  {
    id: IPID,
    header: LABELS.IPID,
  },
  {
    id: SITE_ID,
    header: LABELS.SITE_ID,
  },
  {
    id: MERCHANT_MANAGEMENT_NUMBER,
    header: LABELS.MERCHANT_MANAGEMENT_NUMBER,
  },
  {
    id: SHOP_ID,
    header: LABELS.SHOP_ID,
  },
  {
    id: TERMINAL_IDENTIFICATION_NUMBER,
    header: LABELS.TERMINAL_IDENTIFICATION_NUMBER,
  },
  // Orange項目追加
  //  決済グループID
  {
    id: SETTLEMENT_GROUP_ID,
    header: LABELS.SETTLEMENT_GROUP_ID,
  },
  //  Access Key
  {
    id: ACCESS_KEY,
    header: LABELS.ACCESS_KEY,
  },
  //  Secret Key
  {
    id: SECRET_KEY,
    header: LABELS.SECRET_KEY,
  },
];

/** ドコモユーザProgress以外 */
export const columnDefinitionsBaseNotProgress = [
  {
    id: STATUS,
    header: LABELS.STATUS,
  },
  {
    id: CORPORATE_NUMBER,
    header: LABELS.CORPORATE_NUMBER,
  },
  {
    id: DUNS_NO,
    header: LABELS.DUNS_NO,
  },
  {
    id: COMPANY_NAME,
    header: LABELS.COMPANY_NAME,
  },
  {
    id: CONTRACT_SERVICE,
    header: LABELS.CONTRACT_SERVICE,
  },
  {
    id: MERCHANTS_TYPE,
    header: LABELS.MERCHANTS_TYPE,
  },
  {
    id: MERCHANTS_NAME,
    header: LABELS.MERCHANTS_NAME,
  },
  {
    id: CONTRACT_TYPE,
    header: LABELS.CONTRACT_TYPE,
  },
  {
    id: CONTRACT_ROUTE,
    header: LABELS.CONTRACT_ROUTE,
  },
  {
    id: QR_PRESENTATION_CATEGORY,
    header: LABELS.QR_PRESENTATION_CATEGORY,
  },
  {
    id: IPID,
    header: LABELS.IPID,
  },
  {
    id: SITE_ID,
    header: LABELS.SITE_ID,
  },
  {
    id: MERCHANT_MANAGEMENT_NUMBER,
    header: LABELS.MERCHANT_MANAGEMENT_NUMBER,
  },
];

/** ドコモユーザ以外 */
export const columnDefinitionsBaseNotDocomo = [
  {
    id: STATUS,
    header: LABELS.STATUS,
  },
  {
    id: CORPORATE_NUMBER,
    header: LABELS.CORPORATE_NUMBER,
  },
  {
    id: COMPANY_NAME,
    header: LABELS.COMPANY_NAME,
  },
  {
    id: CONTRACT_SERVICE,
    header: LABELS.CONTRACT_SERVICE,
  },
  {
    id: MERCHANTS_NAME,
    header: LABELS.MERCHANTS_NAME,
  },
  {
    id: QR_PRESENTATION_CATEGORY,
    header: LABELS.QR_PRESENTATION_CATEGORY,
  },
  {
    id: IPID,
    header: LABELS.IPID,
  },
  {
    id: SITE_ID,
    header: LABELS.SITE_ID,
  },
  {
    id: MERCHANT_MANAGEMENT_NUMBER,
    header: LABELS.MERCHANT_MANAGEMENT_NUMBER,
  },
];
